import {
    PARTNER_PORTAL_SETTINGS_FETCH,
    PARTNER_PORTAL_SETTINGS_FETCH_SUCCESS,
    PARTNER_PORTAL_SETTINGS_FETCH_FAIL
} from '../constants/ActionTypes';
  
const initialState = {
    partnerPortalSettings: {},
    loadingPartnerPortalSettings: false
};
  
export default function(state = initialState, action) {
    switch (action.type) {
        case PARTNER_PORTAL_SETTINGS_FETCH:
            return {
                ...state,
                loadingPartnerPortalSettings: true
            }
        case PARTNER_PORTAL_SETTINGS_FETCH_SUCCESS:
            return {
                ...state,
                partnerPortalSettings: action.partnerPortalSettings,
                loadingPartnerPortalSettings: false
            }
        case PARTNER_PORTAL_SETTINGS_FETCH_FAIL:
            return {
                ...state
            }
        default:
        return state;
    }
}